module.exports = __webpack_public_path__ + "static/media/radiation.36acc55f.svg";